import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../../data/content";

export default function ServicesSnapshot({ count = 6 }) {
  return (
    <section className="bg-white border-y border-black/5">
      <div className="container-wide py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div className="max-w-2xl">
            <div className="eyebrow mb-3">Care we provide</div>
            <h2 className="text-3xl md:text-5xl font-heading leading-[1.05]">
              Services designed around real recovery.
            </h2>
          </div>
          <Link to="/services" className="btn-outline w-fit">
            All services <ArrowRight size={16} />
          </Link>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {SERVICES.slice(0, count).map((s) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              data-testid={`service-${s.slug}`}
              className="card-soft p-6 hover:shadow-[0_16px_50px_rgb(0,0,0,0.08)] transition-shadow group"
            >
              <div className="text-xs uppercase tracking-widest text-brand-amber">{s.tag}</div>
              <h3 className="font-heading text-xl text-brand-ink mt-2 group-hover:text-brand-blue">{s.title}</h3>
              <p className="text-sm text-brand-ink2 mt-2">{s.blurb}</p>
              <div className="mt-4 text-sm text-brand-blue inline-flex items-center gap-1">
                Learn more <ArrowRight size={14} />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
